import loading from "../../assets/images/icons/loading.gif";
import { t } from "../../content";

function Loading({ sectionLoading, containerHeight }) {
  return sectionLoading ? (
    <div
      className="section-loading"
      style={{ height: containerHeight || "100%" }}
    >
      <img className="gif" src={loading} alt={t("common.labels.loading")} />
    </div>
  ) : (
    <div className="loading">
      <img className="gif" src={loading} alt={t("common.labels.loading")} />
    </div>
  );
}

export default Loading;
